import { Link } from "react-router-dom";
import { ChevronRight } from "./icons";
import { useLanguage } from "../context/LanguageContext";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

// Shown on every page except the homepage. "Главная" is prepended
// automatically — callers only pass the trail after it. The last item never
// links (it's the current page) even if it has an href.
export default function Breadcrumbs({ items }: { items: BreadcrumbItem[] }) {
  const { t } = useLanguage();
  const allItems: BreadcrumbItem[] = [{ label: t("breadcrumbHome"), href: "/" }, ...items];

  return (
    <div className="bg-steel-50">
      <div className="container-industrial flex flex-wrap items-center gap-1.5 py-3 text-sm">
        {allItems.map((item, i) => {
          const isLast = i === allItems.length - 1;
          return (
            <span key={i} className="flex items-end gap-1.5">
              {i > 0 && <ChevronRight size={18} className="shrink-0 text-accent" />}
              {item.href && !isLast ? (
                <Link
                  to={item.href}
                  className="font-semibold text-ink transition-colors duration-200 ease-engineered hover:text-accent"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-steel-400" : "font-semibold text-ink"}>
                  {item.label}
                </span>
              )}
            </span>
          );
        })}
      </div>
    </div>
  );
}
